import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import YouTube from '../../components/youtube';
import { useHighlightByUuid } from '../../hooks/use-highlights';

import styles from './highlight-youtube.module.scss';

const HighlightYouTube = ({ uuid }) => {
	const { youtube_id: id, name: title, text } = useHighlightByUuid(uuid) || {};

	return (
		<Fragment>
			<h2 className={styles.title}>{title}</h2>
			<YouTube id={id} />
			{text && <div className={styles.text}>{text}</div>}
		</Fragment>
	);
};

HighlightYouTube.defaultProps = {
	uuid: null
};

HighlightYouTube.propTypes = {
	uuid: PropTypes.string.isRequired
};

export default HighlightYouTube;
